import React, { useEffect, useState, useRef } from 'react';
import './index.css';
import { useInView } from 'react-intersection-observer';
import LcIconLink, { Size, Position } from '../../Generic/LcIconLink';
import LcDropDown from '../../Generic/LcDropDown';
import Parse from 'html-react-parser';
import { OptionsTooltips } from '../../../models/OptionsTooltips';
import LcIcon from '../../Generic/LcIcon';
import HHDetailTooltip from '../../Generic/HHDetailTooltip';
import moment from 'moment';
import StatusColorDisplay from '../../Generic/StatusColorDisplay';
import { ExportToCsv } from "export-to-csv-file";
import { SolicitationView } from '../../../models/SolicitationView';
import { useSelector } from 'react-redux';
import { MenuState } from '../../../store/reducers/menuReducer';
import { PrefState } from '../../../store/reducers/prefReducer';
import { RootState } from '../../../store/index';
import TextTools from "../../../services/TextTools/TextTools";
import { Field } from "../../../models/Field";
import { Period } from "../../../models/Period";
import { escapeRegExp } from 'lodash';
import SolicitationService from '../../../services/SolicitationService/SolicitationService';
import ExportList from '../../Form/ExportList';

//Campos do Filtro
interface FilterField {
    label: string,
    name: string,
    type: string,
    value?: string,
    options?: any[],
    show?: boolean,
}

//Objeto do Filtro
interface FilterData {
    fields: FilterField[],
    onChange: Function
}

interface Sort {
    column: string,
    direction: string
}

type FontSize = 'tiny' | 'small' | 'medium' | 'large' | 'big';

interface Props {
    loading?: boolean,
    rows: object[],
    rowClick?: {
        rowPointer: boolean,
        rowFunction: Function,
        rowSelected?: any
    },
    columns: object[],
    tootipProperties?: {
        montaFields: Function,
        searchExpandedFields: Function,
        optionsProperties: OptionsTooltips
    },
    functions?: {
        icon: string,
        tooltip?: string,
        func: Function,
        disabled?: boolean
    }[],
    functionGeneric?: {
        hide?: boolean
        id?: string;
        icon: string,
        iconDisabled?: {
            color: string,
            tooltip: string,
        },
        tooltip?: string,
        badge?: { number: number, status: string },
        func?: Function,
        disabled?: boolean,
        size?: Size,
        isSelection?: boolean,
        tooltipPosition?: Position,
        selection?: {
            contents: Period[],
            onChange: Function
        },

        isFilter?: boolean,
        isFilterCampo?: {
            isLoadingContents: boolean,
            contents: Period[],
            onChange: Function,
            onChangePesquisa: Function,
            dropDownOptions: Field[],
            onClickOption: Function
        },
    }[],
    functionsRow?: {
        label: string,
        func: Function,
        disabled?: Function,
        hidden?: Function
    }[],

    loadMore: Function,
    size: number, //Tamanho total dos dados retornado pela API
    height?: string,
    fontSize?: FontSize,
    onSortChange?: Function,
    onSelectChange?: Function,
    filter?: FilterData,
    status?: Function,
    manufacturerUpdatedAt?: string,
    handleSelectedRowId: Function,
    selectedRadioRows: any
    handleReload?: true
}

const HHSolicitationsTable: React.FC<Props> = (props) => {
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const { ref, inView } = useInView({});
    const [clientHeight, setClientHeight] = useState<number>(0);
    const [filter, setFilter] = useState<FilterField[] | undefined>(props.filter?.fields);
    const [asFilter, setAsFilter] = useState<boolean>(false);
    const [modalFilterVisible, setModalFilterVisible] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<object[]>([]);
    const [sort, setSort] = useState<Sort>();
    const [selection, setSelection] = useState<Period>();
    const [dropDown, setDropDown] = useState<boolean>(false);
    const [options, setOptions] = useState<Field[]>([])
    const [selectedRadioRows, setSelectedRadioRows] = useState<number>();
    const dateTimeNow = new Date();
    const [dateReload, setDateReload] = useState<any>(undefined);
    const momentDateTimeNow = moment(dateTimeNow.toISOString());
    const textTools = new TextTools();
    const solicitationService = new SolicitationService(props);
    const [showExport, setShowExport] = useState<boolean>(false);

    useEffect(() => {
        props.functionGeneric?.map(item => {
            let selectedTemp = item.isFilterCampo?.dropDownOptions;

            if (selectedTemp != undefined) {
                setOptions(selectedTemp);
            }
        })
    }, [])

    const templateMais: Period = {
        label: "mais",
        text: "mais",
        fields: [{
            name: "mais",
            value: "mais"
        }]
    };

    const templateEditar: Period = {
        label: "edit",
        text: "edit",
        fields: [{
            name: "edit",
            value: "edit"
        }]
    };

    const templateHelper: Period[] = [
        {
            label: "Teste de Template",
            text: "Teste de Template",
            fields: [{
                name: "Teste de Template",
                value: "Teste de Template"
            }]
        }
    ]

    const handleFilterAdvanced = (event: any) => {
        event.preventDefault();

        setSelectedRows([]);

        let _filterAdvanced = Object.assign([], filter);
        let filterCount = 0;
        filter && filter.map(f => {
            _filterAdvanced.find((l: FilterField) => l.name === event.target[f.name].name ? f.value = event.target[f.name].value : false)
            filterCount += event.target[f.name].value.length;
        });
        setAsFilter(filterCount > 0);
        props.filter?.onChange(_filterAdvanced, clientHeight);
        setModalFilterVisible(false);
    }

    const handleFilterClear = () => {
        setAsFilter(false);
        var _filter = filter?.map((f: any) => {
            return {
                ...f,
                value: ""
            }
        })
        props.filter?.onChange(_filter, clientHeight);
    }

    const handleSort = (column: string) => {
        !sort || sort.column !== column
            ? setSort({ column, direction: 'asc' })
            : setSort({ ...sort, direction: sort.direction === 'asc' ? 'desc' : 'asc' })
    }

    useEffect(() => {
        if (props.onSortChange && sort) {
            props.onSortChange({ sort, size: clientHeight });
        }
    }, [sort])

    useEffect(() => {
        props.onSelectChange &&
            props.onSelectChange(selectedRows);
    }, [selectedRows])

    const getStatusRow = (status: string) => {
        const statusMap: { [key: string]: string } = {
            'primary': '#141b4d',
            'secondary': '#1b3a7a',
            'danger': '#e64646',
            'success': '#a5bf3e',
            'warning': '#ffb800',
            'link': '#0580ce'
        };

        return statusMap[status] || status;
    };

    const onChangeSelection = (selection: Period) => {
        setSelection(selection);
        props.functionGeneric?.map(teste => {
            teste.selection?.onChange(selection);
        })
    }

    const onChangeSelectionFilter = (selection: Period) => {
        setSelection(selection);
        props.functionGeneric?.map(teste => {
            teste.isFilterCampo?.onChange(selection);
        })
    }

    const [search, setSearch] = useState<string>("");

    const searchValue = (e: any) => {
        setSearch(e.target.value);
        props.functionGeneric?.map(teste => {
            teste.isFilterCampo?.onChangePesquisa(e.target.value);
        })
    }

    useEffect(() => {
        if (props.rows && props.rows.length > 0) {
            setDateReload(new Date());
        }
    }, [props.rows])

    const clearValue = () => {
        setSearch("");
        setDropDown(false);
        props.functionGeneric?.map(teste => {
            teste.isFilterCampo?.onChangePesquisa("");
        })
    }

    const handleClickOptions = (e: any) => {
        props.functionGeneric?.map(teste => {

            if (teste.isFilterCampo) {
                let selectedTemp = options;

                selectedTemp.map((x: Field) => {
                    if (x.name == e.name) x.value = !x.value;
                })

                setOptions([...selectedTemp]);
                teste.isFilterCampo?.onClickOption(selectedTemp);
            }
        })
    }

    const [selectedRowId, setSelectedRowId] = useState<any>();

    const handleHidden = (row: any, isOnSelectedRowsRadio: any) => {
        if (isOnSelectedRowsRadio && row.id == isOnSelectedRowsRadio.id) {
            return false;
        }
        else if (selectedRowId == undefined) {
            return true;
        }
        else if (row.id != selectedRowId) {
            return true;
        }
        else {
            return false;
        }
    }

    const searchInput = useRef<any>(null);

    useEffect(() => {
        if (dropDown) {
            searchInput.current.focus();
        }
        else {
            setSearch("");
        }
    }, [dropDown]);

    const handleRowClick = (row: any, iCol: number) => {
        if (iCol !== 0) {
            props.rowClick && props.rowClick.rowFunction(row);
        }
    }

    const [mousePosition, setMousePosition] = useState<{ x: number, y: number }>({ x: 0, y: 0 });

    const handleMouseMove = (event: any, rowId: number) => {
        setMousePosition({ x: event.pageX, y: event.pageY });
        props.handleSelectedRowId(rowId);
    }

    const [openIconSearch, setOpenIconSearch] = useState<boolean>(false);

    useEffect(() => {
        const openClickSearch = pref.dataLocal?.openClickSearch ?? false;

        if (openClickSearch) {
            let searchSolicitation: any = document.getElementById('searchSolicitation');

            if (searchSolicitation) {
                searchSolicitation.click();
                setOpenIconSearch(true);

                let searchTextSolicitante: any = document.getElementById('searchSolicitationText');

                if (searchTextSolicitante) {
                    setSearch("teste");

                    let searchDropDown: any = document.getElementById('searchDropDown');
                    searchDropDown && searchDropDown.click();
                }
            }
        }
        else {
            if (openIconSearch) {
                let searchSolicitation: any = document.getElementById('searchSolicitation');
                searchSolicitation && searchSolicitation.click();

                setOpenIconSearch(false);
            }
        }
    }, [pref.dataLocal?.openClickSearch])

    useEffect(() => {
        const openTemplates = pref.dataLocal?.openTemplates ?? false;

        if (openTemplates) {
            const item = document.getElementById("dropdownTemplate");

            if (!item) {
                let el = document.getElementById("templateListSelection") as any;
                el && el.click();
            }
        }
        else {
            const item = document.getElementById("dropdownTemplate");

            if (item) {
                let el = document.getElementById("templateListSelection") as any;
                el && el.click();
            }
        }
    }, [pref.dataLocal?.openTemplates])

    useEffect(() => {
        setDropDown(false);
    }, [menu.showHelper]);

    const [hideAllTooltips, setHideAllTooltips] = useState<boolean>(false);

    return (
        <div
            id="lcdti"
            className="lc-datatableinfinite"
            style={{ height: props.height || '100%' }}
            onMouseEnter={() => setHideAllTooltips(false)}
            onMouseLeave={() => setHideAllTooltips(true)}
        >
            <div className='fixedHeader'>
                <div className="topbar">
                    <div className="functions">
                        {
                            props.functions &&
                            <>
                                {
                                    props.functions.map((func, index) => {
                                        return <LcIconLink
                                            tooltipPosition={index === 0 ? 'right' : undefined}
                                            disabled={func.disabled || false}
                                            key={index}
                                            icon={func.icon}
                                            tooltip={func.tooltip}
                                            onClick={() => { func.func(selectedRows) }} />
                                    })
                                }
                            </>
                        }
                        {
                            props.functionGeneric &&
                            <div>
                                {
                                    props.functionGeneric.map((func, index) => {
                                        if (func.isSelection) {
                                            let listaTemplate: Period[] = [];

                                            if (menu.showHelper) {
                                                listaTemplate = templateHelper;
                                            }
                                            else {
                                                if (func.selection?.contents) {
                                                    listaTemplate = func.selection?.contents;
                                                }
                                            }

                                            return (
                                                <>
                                                    {
                                                        <LcDropDown
                                                            class='mobile'
                                                            key={'LcDropDown' + index}
                                                            style={{ display: dropDown && window.screen.width < 600 ? 'none' : 'flex', margin: !func.hide ? "15px 10px 0px -10px" : "0px" }}
                                                            element={
                                                                <span className="select-period">
                                                                    {
                                                                        (!func.hide)
                                                                            ? <LcIconLink
                                                                                icon={func.icon}
                                                                                size={func.size || "small"}
                                                                                tooltip={func.tooltip}
                                                                                tooltipPosition={func.tooltipPosition}
                                                                                id={"templateListSelection"} />

                                                                            : <LcIconLink
                                                                                icon={'ppi ppi-template'}
                                                                                tooltip={func.tooltip}
                                                                                tooltipPosition={func.tooltipPosition} />
                                                                    }
                                                                </span>
                                                            }>
                                                            <div id={"dropdownTemplate"}>
                                                                {
                                                                    (listaTemplate.length > 0)
                                                                        ? <div style={{ width: "max-content", maxWidth: "15rem" }} key={'functionscellshidden' + index}>
                                                                            {
                                                                                // func.selection?.contents.slice(0, 7).map((p, i) => {
                                                                                listaTemplate.slice(0, 7).map((p, i) => {
                                                                                    return <span key={i} className="item" onClick={() => onChangeSelection(p)}>{p.label}</span>
                                                                                })
                                                                            }

                                                                            <>
                                                                                <hr />
                                                                                {
                                                                                    (window.screen.width > 600)
                                                                                        ? <div className='optionsTemplate' key={'functionscellshidden' + index} style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "center", justifyContent: "space-between" }}>
                                                                                            <span key={'onChangeSelectiontemplateschevron' + index}
                                                                                                className="item"
                                                                                                onClick={() => onChangeSelection(templateEditar)}>
                                                                                                Gerenciar templates</span>
                                                                                            <LcIconLink key={'templateschevron' + index} icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                                        </div>
                                                                                        : <div className='optionsTemplate' key={'functionscellshidden' + index} style={{ display: "flex", flexDirection: "row", flexWrap: "nowrap", alignItems: "center", justifyContent: "space-between" }}>
                                                                                            <span key={'LcIconLinkectiontitem' + index} className="item"
                                                                                                onClick={() => onChangeSelection(templateEditar)}
                                                                                            > Mais templates </span>
                                                                                            {/* {
                                                                                        window.screen.width > 600 &&
                                                                                        <LcIconLink key={'LcIconLinkectiontemplateschevron' + index} icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                                    } */}
                                                                                        </div>
                                                                                }
                                                                            </>
                                                                        </div>
                                                                        : <span className="item" key={'templates' + index}> Sem templates salvos </span>
                                                                }
                                                            </div>
                                                        </LcDropDown>
                                                    }
                                                </>
                                            )
                                        }

                                        if (func.isFilter) {
                                            let count = 0;

                                            return (
                                                <>
                                                    {
                                                        (window.screen.width > 600)
                                                            ? <>
                                                                <LcIcon icon={"ppi ppi-divider-vertical"} color={"#B5B7C6"} />
                                                                <LcIconLink tooltip='Pesquisar Chamado' key={'functionscellshidden' + index} icon={"ppi ppi-search"} onClick={() => setDropDown(!dropDown)} id={"searchSolicitation"} activedAfterClick={dropDown} />
                                                                {/* <LcIconLink tooltip='Exportar para CSV' onClick={() => exportToCSV()} icon={"ppi ppi-document-download"} /> */}
                                                                <ExportList visible={showExport} setVisible={setShowExport} list={props.rows} columns={props.columns} />
                                                                <LcIconLink tooltip='Exportar solicitações' onClick={() => setShowExport(!showExport)} icon={"ppi ppi-document-download"} />
                                                                <div key={'hiddenfunctionscellshidden' + index} hidden={!dropDown} >
                                                                    <div key={'LcDropDowndivfunctionscellshidden' + index} style={{ marginBottom: "-30px" }}>
                                                                        <LcDropDown key={'functionscellshidden' + index}
                                                                            id={"searchDropDown"}
                                                                            width={"500px"}
                                                                            // width={"fit-content"}
                                                                            element={
                                                                                <div key={'styledivfunctionscellshidden' + index} style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                                                                    <input key={'inputfunctionscellshidden' + index}
                                                                                        type="text"
                                                                                        className={"searchTextSolicitante"}
                                                                                        ref={searchInput}
                                                                                        onChange={searchValue}
                                                                                        value={search.replace("> ", "")}
                                                                                        autoComplete='false'
                                                                                        onKeyPress={(event) => { if (event.key === "Enter") onChangeSelectionFilter(templateMais) }}
                                                                                        id={"searchSolicitationText"}
                                                                                        placeholder="Pesquise pelo número de seu chamado ou assunto e pressione Enter"
                                                                                    />
                                                                                    <LcIconLink key={'LcIconLinkfunctionscellshidden' + index} icon={"ppi ppi-x"} size='small' onClick={() => clearValue()} />
                                                                                </div>
                                                                            }
                                                                            onEnterClose={true}
                                                                            trigger={(menu.showHelper) ? "click" : "keyPress"}
                                                                        >
                                                                            {
                                                                                <>
                                                                                    {
                                                                                        func.isFilterCampo?.isLoadingContents
                                                                                            ? <span className="item" key={'itemfunctionscellshidden' + index}>Carregando...</span>
                                                                                            : <>
                                                                                                {
                                                                                                    func.isFilterCampo?.contents.length == 0
                                                                                                        ? <span key={'spanfunctionscellshidden' + index} className="item">Nenhum resultado encontrado</span>
                                                                                                        : <div key={'divfunctionscellshidden' + index} style={{ maxHeight: "75vh" }}>
                                                                                                            {
                                                                                                                func.isFilterCampo?.contents.slice(0, 7).map((p, i) => {
                                                                                                                    var result_ = '';
                                                                                                                    var resultHtml = ''
                                                                                                                    if (typeof p.label === 'string' && typeof search === 'string') {
                                                                                                                        var searchMask = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                                                                                                                        searchMask = escapeRegExp(searchMask);
                                                                                                                        var regEx = new RegExp(searchMask, "ig");
                                                                                                                        var replaceMask = `<strong>${searchMask}</strong>`;

                                                                                                                        result_ = p.label.replace(/[\u0300-\u036f]/g, "")
                                                                                                                        result_ = textTools.cleanTagEmailParse(result_);
                                                                                                                        resultHtml = result_.replace(regEx, replaceMask)
                                                                                                                    }

                                                                                                                    return (
                                                                                                                        <span key={i} className="item" onClick={() => onChangeSelectionFilter(p)}>
                                                                                                                            {Parse(resultHtml)}
                                                                                                                        </span>
                                                                                                                    )
                                                                                                                })
                                                                                                            }
                                                                                                            {
                                                                                                                func.isFilterCampo && func.isFilterCampo?.contents.length > 0 &&
                                                                                                                <>
                                                                                                                    <hr />
                                                                                                                    <span key={'spanfunctionscellshidden' + index}
                                                                                                                        className="item"
                                                                                                                        onClick={() => onChangeSelectionFilter(templateMais)}
                                                                                                                        style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", alignItems: "center" }}
                                                                                                                    >
                                                                                                                        Mais resultados
                                                                                                                        <LcIconLink key={'LcIconLinkscellshidden' + index} icon={"ppi ppi-chevron-right"} size={"small"} />
                                                                                                                    </span>
                                                                                                                </>
                                                                                                            }
                                                                                                        </div>
                                                                                                }
                                                                                            </>
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </LcDropDown>


                                                                        {/* <LcDropDown key={'spanfunctionscellshidden' + index} trigger='click' element={<LcIconLink key={'LcDropDownfunctionscellsn' + index} icon={"ppi ppi-chevron-down"} size={"small"} />} width={"250px"} hold={true}>
                                                                            {
                                                                                options.map((option) => {

                                                                                    return (
                                                                                        <div key={'optionsindexitem' + index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center" }}>
                                                                                            <input key={'spanfunitemn' + index} type="checkbox" style={{ float: "left", marginRight: "10px" }} onClick={() => handleClickOptions(option)} checked={(option.value == true) ? true : false} />
                                                                                            <span key={'spanfuitem' + index} className="item" style={{ marginTop: "5px" }}
                                                                                            > {option.label} </span>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </LcDropDown> */}
                                                                    </div>
                                                                </div>
                                                            </>
                                                            : <>
                                                                {
                                                                    !dropDown &&
                                                                    <LcIconLink key={'functionscellshidden' + index} icon={"ppi ppi-search"} onClick={() => setDropDown(!dropDown)} />
                                                                }
                                                                <div key={'hiddenfunctionscellshidden' + index} hidden={!dropDown} >
                                                                    <div key={'LcDropDowndivfunctionscellshidden' + index} style={{ background: '#fff', width: '90vw' }}>
                                                                        <LcDropDown key={'functionscellshidden' + index}
                                                                            width={'100vw'}
                                                                            // width={"fit-content"}
                                                                            // trigger={"hover"}
                                                                            element={
                                                                                <div key={'styledivfunctionscellshidden' + index} style={{ width: '90vw', display: "flex", flexDirection: "row", alignItems: 'center' }}>
                                                                                    <input key={'inputfunctionscellshidden' + index}
                                                                                        type="text"
                                                                                        className={"searchTextSolicitante"}
                                                                                        ref={searchInput}
                                                                                        onChange={searchValue}
                                                                                        value={search.replace("> ", "")}
                                                                                        autoComplete='false'
                                                                                        onKeyPress={(event) => { if (event.key === "Enter") onChangeSelectionFilter(templateMais) }}
                                                                                    />
                                                                                    <LcIconLink key={'LcIconLinkfunctionscellshidden' + index} icon={"ppi ppi-x"} size='small' onClick={() => clearValue()} />
                                                                                    <LcIconLink key={'functionscellshidden' + index} icon={"ppi ppi-search"} onClick={() => onChangeSelectionFilter(templateMais)} />
                                                                                </div>
                                                                            }
                                                                            onEnterClose={true}
                                                                            trigger={"keyPress"}
                                                                            class={'searchMobile'}
                                                                        >
                                                                            {
                                                                                (func.isFilterCampo?.isLoadingContents)
                                                                                    ? <span className="item" key={'itemfunctionscellshidden' + index}>Carregando...</span>
                                                                                    : <>
                                                                                        {
                                                                                            (func.isFilterCampo?.contents.length == 0)
                                                                                                ? <span key={'spanfunctionscellshidden' + index} className="item">Nenhum resultado encontrado</span>
                                                                                                : <div key={'divfunctionscellshidden' + index} style={{ maxHeight: "75vh" }}>
                                                                                                    {
                                                                                                        func.isFilterCampo?.contents.slice(0, 7).map((p, i) => {
                                                                                                            // count++;

                                                                                                            // if (count < 7) {

                                                                                                            var result_ = '';

                                                                                                            if (typeof p.label === 'string' && typeof search === 'string') {
                                                                                                                var searchMask = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
                                                                                                                var regEx = new RegExp(searchMask, "ig");
                                                                                                                var replaceMask = `<b>${searchMask}</b>`;

                                                                                                                result_ = p.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(regEx, replaceMask);
                                                                                                            }

                                                                                                            return (
                                                                                                                <span key={i} className="item" onClick={() => onChangeSelectionFilter(p)} >
                                                                                                                    {Parse(result_)}
                                                                                                                </span>
                                                                                                            )
                                                                                                            // }
                                                                                                        })
                                                                                                    }
                                                                                                </div>
                                                                                        }
                                                                                    </>
                                                                            }
                                                                        </LcDropDown>

                                                                        {/* <LcDropDown key={'spanfunctionscellshidden' + index} trigger='click' element={<LcIconLink key={'LcDropDownfunctionscellsn' + index} icon={"ppi ppi-chevron-down"} size={"small"} />} width={"250px"} hold={true}>
                                                                            {
                                                                                options.map((option) => {

                                                                                    return (
                                                                                        <div key={'optionsindexitem' + index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyItems: "center" }}>
                                                                                            <input key={'spanfunitemn' + index} type="checkbox" style={{ float: "left", marginRight: "10px" }} onClick={() => handleClickOptions(option)} checked={(option.value == true) ? true : false} />
                                                                                            <span key={'spanfuitem' + index} className="item" style={{ marginTop: "5px" }}
                                                                                            > {option.label} </span>
                                                                                        </div>
                                                                                    )
                                                                                })
                                                                            }
                                                                        </LcDropDown> */}
                                                                    </div>
                                                                </div>
                                                            </>
                                                    }
                                                </>
                                            )
                                        }

                                        if (func.iconDisabled) {
                                            if (props.selectedRadioRows && props.selectedRadioRows.length > 0) {
                                                return <LcIconLink
                                                    id={func.id}
                                                    tooltipPosition={index === 0 ? 'right' : undefined}
                                                    key={index}
                                                    icon={func.icon}
                                                    tooltip={func.tooltip}
                                                    onClick={func.func} />
                                            }
                                            else if (!func.hide) {
                                                return <LcIcon
                                                    id={func.id}
                                                    icon={func.icon}
                                                    tooltipPosition={index === 0 ? 'right' : undefined}
                                                    key={index}
                                                    tooltip={func.iconDisabled.tooltip}
                                                    color={func.iconDisabled.color} />
                                            }
                                        }
                                        else if (!dropDown && window.screen.width < 600) {
                                            return <LcIconLink
                                                id={func.id}
                                                tooltipPosition={index === 0 ? 'right' : undefined}
                                                key={index}
                                                icon={func.icon}
                                                tooltip={func.tooltip}
                                                onClick={func.func} />
                                        }
                                        else if (window.screen.width > 600) {
                                            return <LcIconLink
                                                id={func.id}
                                                tooltipPosition={index === 0 ? 'right' : undefined}
                                                key={index}
                                                icon={func.icon}
                                                tooltip={func.tooltip}
                                                onClick={func.func} />
                                        }
                                    })
                                }
                            </div>
                        }
                        {
                            props.handleReload &&
                            <>
                                {
                                    dateReload && !menu.fullScreen &&
                                    <span style={{ fontSize: "12px", color: "#8B90A3", fontStyle: 'normal', lineHeight: '150%', marginLeft: '10px' }}>{`Atualizado ${moment(dateReload).fromNow()}`}</span>
                                }
                            </>
                        }
                    </div>
                </div>

                <div className="header" style={{ position: 'sticky', display: (!props.rows || (props.rows && props.rows.length !== 0)) && window.screen.width > 600 ? 'flex' : 'none' }}>
                    {
                        props.onSelectChange &&
                        <div className="selectable" >
                            <i
                                className={`ppi ppi-checkbox${selectedRows.length > 0 ? '-on text-warning' : ' text-grey'}`}
                                onClick={() => { setSelectedRows(selectedRows.length > 0 ? [] : props.rows) }}
                            />
                        </div>
                    }
                    {
                        props.columns.map((c: any, i: number) => {
                            return c.hide !== true && (
                                <div
                                    className={`cell ${props.onSortChange && c.sort !== false ? 'sortable' : ''} ${sort?.column === c.field ? 'text-link' : ''}${c.align || ''}`}
                                    style={{ width: c.width, display: 'flex', alignItems: 'center' }}
                                    key={i}
                                    onClick={() => { c.sort !== false && props.onSortChange && handleSort(c.field) }}
                                >
                                    <span key={i}> {c.headerName} </span>
                                    {
                                        c.headerName && sort && sort.column === c.field &&
                                        <i className={`ppi ppi-arrow-${(sort.direction === 'asc') ? 'down' : 'up'}`} style={{ marginLeft: "3px" }} />
                                    }
                                </div>
                            )
                        })
                    }
                    {
                        props.functionsRow &&
                        <div className="cell" />
                    }
                </div>
            </div>
            {/*{*/}
            {/*    props.size > clientHeight && (props.rows && props.rows.length < props.size) &&*/}
            {/*    <div className="loader">*/}
            {/*        <div ref={ref}>*/}
            {/*            {*/}
            {/*                !inView ?*/}
            {/*                    <>*/}
            {/*                        <i className="ppi ppi-refresh text-warning" /> &nbsp;Carregando...*/}
            {/*                    </>*/}
            {/*                    :*/}
            {/*                    // <i className="ppi ppi-dots-horizontal" />*/}
            {/*                    <></>*/}
            {/*            }*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*}*/}
            {/*{*/}
            {/*    (props.size > clientHeight && (props.rows && props.rows.length < props.size)*/}
            {/*    ) && props.loading &&*/}
            {/*    <div className="loader">*/}
            {/*        <>*/}
            {/*            {*/}
            {/*                <>*/}
            {/*                    <i className="ppi ppi-refresh text-warning" />&nbsp;Carregando...*/}
            {/*                </>*/}
            {/*            }*/}
            {/*        </>*/}
            {/*    </div>*/}
            {/*}*/}
            <div id='frameList' className='frame'>
                <div className="body">
                    {
                        props.rows &&
                        props.rows.map((row: any, iRow: number,) => {
                            const time = new Date(row.registrationDate).toLocaleTimeString().slice(0, -3);
                            const data = (momentDateTimeNow.format("YYYY-MM-DD") !== moment(row.registrationDate).format("YYYY-MM-DD"))
                                ? moment(row.registrationDate).fromNow()
                                : time;

                            const selectedRadioRowsId = (props.selectedRadioRows && props.selectedRadioRows.length > 0) ? props.selectedRadioRows[0].id : 0;

                            return (
                                <div
                                    // className={(selectedRadioRowsId === row.id) ? "row selectedRow" : "row"}
                                    className={`row ${(selectedRadioRowsId === row.id) && "selectedRow"} ${props.rowClick && props.rowClick.rowSelected && props.rowClick.rowSelected.id === row.id && "selectedDetails"}`}
                                    key={iRow}
                                    data-tip={iRow}
                                    data-for={"rowDetails " + iRow}
                                    onMouseOver={(e) => handleMouseMove(e, row.id)}
                                    // onClick={() => setSelectedRadioRows(iRow)}
                                    // onMouseLeave={() => props.handleSelectedRowId(0)}
                                // style={{ backgroundColor: (props.rowClick && props.rowClick.rowSelected && props.rowClick.rowSelected.id === row.id) ? "lightgrey !important" : "",}}
                                >
                                    {
                                        window.screen.width > 600 &&
                                        <HHDetailTooltip
                                            key={'HHDetailTooltip' + iRow}
                                            tooltipId={"rowDetails " + iRow}
                                            fields={props.tootipProperties?.montaFields(row)}
                                            searchExpandedFields={props.tootipProperties?.searchExpandedFields}
                                            rowId={row.id}
                                            mousePosition={mousePosition}
                                            hide={true}
                                            hideAllTooltips={hideAllTooltips}
                                            {...props.tootipProperties?.optionsProperties}
                                        />
                                    }

                                    <div key={'HHDetailTooltipstatus' + iRow} className="status" style={{ backgroundColor: props.status && getStatusRow(props.status(row)) }} />
                                    {
                                        (() => {
                                            let isOnSelectedRows = selectedRows.find((r: any) => { return r.id === row.id });

                                            if (props.onSelectChange) {
                                                return (
                                                    <div key={'selectable' + iRow}
                                                        className="selectable"
                                                        onClick={() => {
                                                            (isOnSelectedRows)
                                                                ? setSelectedRows(selectedRows.filter((r: any) => r.id !== row.id))
                                                                : setSelectedRows([...selectedRows, row])
                                                        }}>
                                                        <i key={'selectable' + iRow} className={`ppi ppi-checkbox${isOnSelectedRows ? '-on text-warning' : ' text-grey'}`} />
                                                    </div>
                                                )
                                            }
                                        })()
                                    }

                                    <div className="cells" key={'cells' + iRow}>
                                        {
                                            (window.screen.width > 600)
                                                ? props.columns.map((col: any, iCol: number) => {

                                                    return !col.hide && (
                                                        <div
                                                            key={iCol}
                                                            className={`cell ${props.fontSize || ''} ${col.align || ''} ${col.class || ''}`}
                                                            style={{
                                                                width: col.width,
                                                                overflow: col.overflow,
                                                                cursor: (props.rowClick && props.rowClick.rowPointer === true) ? "pointer" : "auto",
                                                            }}
                                                            onClick={() => handleRowClick(row, iCol)}
                                                        >
                                                            {
                                                                !col.renderCell
                                                                    ? <> {row[col.field]} </>
                                                                    : col.renderCell(row)
                                                            }
                                                        </div>
                                                    )
                                                })

                                                : <div
                                                    key={row.id}
                                                    className='mobileRow'
                                                    onClick={() => handleRowClick(row, 1)}
                                                >
                                                    <div className='headerRow'>
                                                        <label>{row.subject}</label>
                                                        <LcIcon icon={`ppi ppi-${(row.satisfactionSurveyRespond === 1) ? "star-solid" : "star"}`} color={'#141B4D'} />
                                                    </div>
                                                    <div className="infosSolicitation">
                                                        <p className='idRow'>{row.id}</p>
                                                        <p>{data}</p>
                                                        <p className='statusRow'>
                                                            <StatusColorDisplay row={row} type={"solicitation"} />
                                                        </p>
                                                    </div>
                                                </div>
                                        }
                                    </div>

                                    <div className="functions" key={'functionscells' + iRow} style={{ display: window.screen.width > 600 ? 'flex' : 'none' }}>
                                        {
                                            props.functionsRow &&
                                            <LcDropDown key={'selectable' + iRow} element={<LcIconLink icon="ppi ppi-dots-vertical" size="small" />} position="right">
                                                {
                                                    props.functionsRow.map((f, i) => {
                                                        if (!f.hidden || !f.hidden(row)) {
                                                            let disabled = (f.disabled && f.disabled(row)) || false;
                                                            return (
                                                                <div
                                                                    key={'functionscellshidden' + iRow}
                                                                    className={`item${disabled ? ' disabled' : ''}`}
                                                                    onClick={() => { !disabled && f.func(row) }}> {f.label} </div>
                                                            )
                                                        }
                                                    })
                                                }
                                            </LcDropDown>
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                    {
                        props.loading &&
                        <div className="loader">
                            <i className="ppi ppi-refresh text-warning" />&nbsp;Carregando...
                        </div>
                    }
                    {/* {
                        props.size > clientHeight && (props.rows && props.rows.length < props.size) &&
                        <div className="loader">
                            <div ref={ref}>
                                {
                                    !inView &&
                                    <> <i className="ppi ppi-refresh text-warning" />&nbsp;Carregando...</>
                                }
                            </div>
                        </div>
                    } */}
                    {
                        !props.loading && (!props.rows || (props.rows && props.rows.length === 0)) &&
                        <div className="centralized">
                            <i className="ppi ppi-information-circle" />
                            <span> Você não possui nenhum chamado. Clique no botão + para criar um. </span>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default HHSolicitationsTable;